module.exports = __webpack_public_path__ + "media/base/upload-c5508e83.svg";